import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';

import { PageHeaderModule } from 'components/pageHeader/pageHeader.module';
import { PageContentModule } from 'components/pageContent/pageContent.module';
import { SegmentServiceModule } from 'services/tracking/segment/segment.service';

import template from './appShell.html';

export const AppShellComponent = angular
    .module('app.pages.appShell.appShellComponent', [
        uiRouter,
        PageHeaderModule,
        PageContentModule,
        SegmentServiceModule
    ]).component('appShell', {
        template,
        bindings: {
            title: '<',
            src: '<',
            trackingId: '<'
        },
        controller: class AppShellController {
            constructor(
                $scope,
                $window,
                $state,
                $sce,
                segmentService
            ) {
                'ngInject';

                assign(this, {
                    $scope,
                    $window,
                    $state,
                    $sce,
                    segmentService
                });
            }

            $onInit() {
                this.trustedSrc = this.$sce.trustAsResourceUrl(this.src);
                this.$window.addEventListener('message',
                    e => this.onIframeMessage(e, process.env.VALID_IFRAME_ORIGINS));
            }

            $onDestroy() {
                this.$window.removeEventListener('message',
                    e => this.onIframeMessage(e, process.env.VALID_IFRAME_ORIGINS));
            }

            onIframeMessage(event, origins) {
                if (!this.validateIframeEventOrigin(event.origin, origins)) {
                    return;
                }
                const allowedStates = ['dashboard', 'order.list', 'product.list', 'category.list', 'customer.list'];
                if (allowedStates.includes(event.data.state)) {
                    return this.$state.go(event.data.state);
                }
                const allowedDetailStates = [
                    'product.detail', 'order.detail', 'category.detail', 'customer.add', 'customer.edit'
                ];
                if (allowedDetailStates.includes(event.data.state)) {
                    return this.$state.go(event.data.state, { id: event.data.id });
                }
                const allowedAppStates = ['app'];
                const allowedApps = ['mailchimp', 'siteDesigner'];
                if (allowedAppStates.includes(event.data.state) && allowedApps.includes(event.data.id)) {
                    return this.$state.go(event.data.id, { queryString: event.data.queryString });
                }
            }

            validateIframeEventOrigin(eventOrigin, validOrigins) {
                return validOrigins.indexOf(eventOrigin) >= 0;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/appShell/appShell.component.js